export const PAYOUT_STATUS = {
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
  PAID_OUT: "PAID_OUT",
  CREDIT_CLAIMED: "CREDIT_CLAIMED",
  CANCELED: "CANCELED",
} as const;

export const PAYOUT_STATUS_TO_LABEL = {
  [PAYOUT_STATUS.PENDING]: "Pending",
  [PAYOUT_STATUS.ACTIVE]: "Active",
  [PAYOUT_STATUS.PAID_OUT]: "Paid Out",
  [PAYOUT_STATUS.CREDIT_CLAIMED]: "Credit Claimed",
  [PAYOUT_STATUS.CANCELED]: "Canceled",
} as const;

export const PAYOUT_STATUS_TO_PROGRESS = {
  [PAYOUT_STATUS.PENDING]: 1,
  [PAYOUT_STATUS.ACTIVE]: 2,
  [PAYOUT_STATUS.PAID_OUT]: 3,
  [PAYOUT_STATUS.CREDIT_CLAIMED]: 3,
  [PAYOUT_STATUS.CANCELED]: 3,
} as const;
